/* https://www.figma.com/file/GXtg4B5Uy32yVEBVUJahQF/%F0%9F%90%A5-Design-System?type=design&node-id=16535-15744&mode=design&t=zHAuiEEhzCGQ1Lsq-4 */

import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';

import { logEvent } from '../../../features/Analytics/analytics';
import Upload from '../../Upload';
import { UploadProps } from '../../Upload/types';
import SunshineIcon from '../SunshineIcon';
import Text from '../Text';
import locales from './locales';

type FileUploadProps = {
  title?: string;
  subtitle?: string;
} & Pick<
  UploadProps,
  | 'maxByteSizeParam'
  | 'fileTypes'
  | 'onSuccessfulUpload'
  | 'uploadFile'
  | 'onUploadStart'
  | 'onUploadEnd'
>;

const logFileSizeExceeded = (fileByteSize: number, maxByteSize: number) => {
  logEvent({
    name: 'Upload File Size Exceeded',
    properties: {
      fileByteSize,
      maxByteSize,
    },
    usePrefix: false,
  });
};

const FileUpload = ({ subtitle, title, ...props }: FileUploadProps) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Upload
      errorMessage={locales.uploadFailureMessage}
      onFileSizeExceeded={logFileSizeExceeded}
      {...props}
    >
      <Flex align="center" direction="column">
        <Box
          alignItems="center"
          backgroundColor="grey.400"
          borderRadius="radius-12"
          boxSize={40}
          display="flex"
          justifyContent="center"
          marginBottom="space-16"
        >
          <SunshineIcon color="primary" name="download" size="icon-20" />
        </Box>

        <Text fontWeight="weight-500" marginBottom="space-4" variant="primary">
          {title ??
            locales.formatString(
              isMobile
                ? locales.uploadTitle.touch
                : locales.uploadTitle.regular,
            )}
        </Text>

        <Text variant="light">
          {subtitle ?? (isMobile === false ? locales.uploadDescription : null)}
        </Text>
      </Flex>
    </Upload>
  );
};

export default FileUpload;
